export const events = {
  resize: [],
  focus: [],
  blur: [],
};

export function addEvent(name, callback) {
  if (callback) {
    events[name] = events[name] || [];
    events[name].push(callback);
  }
}
export function removeEvent(name, callback) {
  if (callback && events[name]) {
    const index = events[name].findIndex((val) => val === callback);
    if (index > -1) {
      events[name].splice(index, 1);
    }
  }
}
export function emitEvent(name, e) {
  events[name].forEach((callback) => callback(e));
}

// 窗口变化
export function onViewportResize(callback) {
  addEvent('resize', callback);
}
export function removeViewportResize(callback) {
  removeEvent('resize', callback);
}
export function emitViewportResize(e) {
  emitEvent('resize', e);
}

// 获取焦点
export function onFocus(callback) {
  addEvent('focus', callback);
}

export function removeFocus(callback) {
  removeEvent('focus', callback);
}

export function emitFocus(e) {
  emitEvent('focus', e);
}

// 失去焦点
export function onBlur(callback) {
  addEvent('focus', callback);
}

export function removeBlur(callback) {
  removeEvent('focus', callback);
}

export function emitBlur(e) {
  emitEvent('focus', e);
}
